(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-carousel"] && !Shopify.designMode) return;
  try {
    
  function initializeShoppableVideoCarousel(section) {
    if (section.dataset.shoppableVideoCarouselInitialized === 'true') return;

    var track = section.querySelector('[data-shoppable-video-track]');
    var previousButton = section.querySelector('[data-shoppable-video-previous]');
    var nextButton = section.querySelector('[data-shoppable-video-next]');

    if (!track || !previousButton || !nextButton) return;

    section.dataset.shoppableVideoCarouselInitialized = 'true';

    function updateButtons() {
      var hasOverflow = track.scrollWidth > track.clientWidth + 2;

      previousButton.disabled = !hasOverflow || track.scrollLeft <= 2;
      nextButton.disabled = !hasOverflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function scrollTrack(direction) {
      track.scrollBy({
        left: track.clientWidth * 0.85 * direction,
        behavior: 'smooth'
      });
    }

    previousButton.addEventListener('click', function () {
      scrollTrack(-1);
    });

    nextButton.addEventListener('click', function () {
      scrollTrack(1);
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
    setTimeout(updateButtons, 300);
  }

  function initializeAllShoppableVideoCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-shoppable-video-carousel]').forEach(initializeShoppableVideoCarousel);
  }

  initializeAllShoppableVideoCarousels(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllShoppableVideoCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
